module.exports = __webpack_public_path__ + "static/media/foodfinal.eaf7bc82.png";